export const LogoMark = ({ variant = "v1", theme = "light", size = 32, className = "", ...rest }) => {
  const ink = theme === "light" ? "#0D1B2A" : "#C5A880";
  const bg = theme === "light" ? "#FAF9F6" : "#0D1B2A";
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className={className} aria-hidden="true" {...rest}>
      {variant === "v1" && (
        <>
          <circle cx="50" cy="50" r="46" fill="none" stroke={ink} strokeWidth="1.3" />
          <circle cx="47" cy="55" r="17" fill={ink} />
          <circle cx="57" cy="45" r="17" fill={bg} />
          <rect x="31" y="51" width="22" height="5.5" fill={ink} />
        </>
      )}
      {variant === "v2" && (
        <>
          <circle cx="50" cy="50" r="46" fill="none" stroke={ink} strokeWidth="1.3" />
          <circle cx="50" cy="50" r="18" fill={ink} />
          <circle cx="61" cy="39" r="15" fill={bg} />
          <rect x="35" y="47.5" width="17" height="5" fill={ink} />
        </>
      )}
      {variant === "v3" && (
        <>
          <circle cx="50" cy="50" r="46" fill="none" stroke={ink} strokeWidth="1.3" />
          <circle cx="50" cy="52" r="17" fill={ink} />
          <circle cx="41" cy="43" r="17" fill={bg} />
          <rect x="40" y="49" width="17" height="5" fill={ink} />
          <circle cx="50" cy="4.5" r="2.4" fill={ink} />
        </>
      )}
    </svg>
  );
};
